import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Link } from 'react-router-dom';

import { APP_PATH, PERMISSION_UPDATE } from "../../../Utils/Global";
import { getDaysInYear, getWeeksInYear } from "../../../Utils/Utils";
import { getTarificationRows } from "../../../Utils/Tarification";

import PermissionCheck from '../../Permissions/PermissionCheck';

import Tarification from '../Tarification';

class TarificationRecap extends Component {

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.props.object === undefined) {
        return null;
    }

    const rows = getTarificationRows(this.props.object);
    this.rows = rows;

    // Rendering the view
    //this.props.withEdit === true
    console.log('-------');
    console.log(this.props.mode);
    
    console.log(this.props.withEdit);

    return(
      <div className="listContainer" id="tarificationRecapGrid">
        <h4>Récapitulatif de la tarification</h4>
        {(this.props.mode === "edit" ) &&
          <PermissionCheck component={Tarification.getClassName()} permission={PERMISSION_UPDATE}>
            <Link className="tarificationEditLink" to={APP_PATH + "/tarifications/" + this.getObjectProperty("idTarification") + "/edit"}>
              <Button bsStyle="primary">Editer la tarification</Button>
            </Link>
          </PermissionCheck>
        }
        <div className={"grid tarificationRecapGrid"}>
          <BootstrapTable ref={"tableRecapTarificationRecap"} data={rows} trClassName={ this.trClassFormat.bind(this) }>
            <TableHeaderColumn key="index" dataField="index" isKey={true} ref="tableRecapTarificationRecapIndex" dataSort={false} hidden={true}>Index</TableHeaderColumn>
            <TableHeaderColumn key="dateDebut" dataField="dateDebut" isKey={false} ref="tableRecapTarificationRecapDateDebut" dataSort={false}>Du</TableHeaderColumn>
            <TableHeaderColumn key="dateFin" dataField="dateFin" isKey={false} ref="tableRecapTarificationRecapDateFin" dataSort={false}>Au</TableHeaderColumn>
            <TableHeaderColumn key="surface" dataField="surface" isKey={false} ref="tableRecapTarificationRecapSurface" dataSort={false}>Dimension</TableHeaderColumn>
            <TableHeaderColumn key="tarif" dataField="tarif" isKey={false} ref="tableRecapTarificationRecapTarif" dataSort={false}>Tarif</TableHeaderColumn>
            <TableHeaderColumn key="sousTotal" dataField="sousTotal" isKey={false} ref="tableRecapTarificationRecapSousTotal" dataFormat={this.currencyFormatter} dataSort={false}>
              Sous-total</TableHeaderColumn>
            <TableHeaderColumn key="remise1" dataField="remise1" isKey={false} ref="tableRecapTarificationRecapRemise1" dataSort={false}>Remise 1</TableHeaderColumn>
            <TableHeaderColumn key="remise2" dataField="remise2" isKey={false} ref="tableRecapTarificationRecapRemise2" dataSort={false}>Remise 2</TableHeaderColumn>
            <TableHeaderColumn key="totalAnnuel" dataField="totalAnnuel" isKey={false} ref="tableRecapTarificationRecapTotalAnnuel" dataFormat={this.currencyFormatter} dataSort={false}>
              Total annuel</TableHeaderColumn>
            {this.props.withAllParams &&
              <TableHeaderColumn key="estFacture" dataField="estFacture" isKey={false} ref="tableRecapTarificationRecapEstFacture" dataSort={false}>Facturé</TableHeaderColumn>
            }
            {this.props.withAllParams &&
              <TableHeaderColumn key="estSousLoue" dataField="estSousLoue" isKey={false} ref="tableRecapTarificationRecapEstSousLoue" dataSort={false}>Sous-loué</TableHeaderColumn>
            }
          </BootstrapTable>
        </div>
      </div>
    );
	}

  /**
  * trClassFormat
  * Returns the total row class
  **/
  trClassFormat(row, rowIndex) {
    return this.rows && this.rows.length > 1 && rowIndex === this.rows.length - 1 ? "tr-total-row" : "";
  }

  /**
  * getObjectProperty
  * Returns the value for the current state's matching property
  **/
  getObjectProperty(property) {
    return (this.props.object !== undefined && this.props.object[property] !== undefined && this.props.object[property] !== null) ? this.props.object[property] : "";
  }

  /**
  * getSubObjectProperty
  * Returns the sub property value
  **/
  getSubObjectProperty(arrProperties, object) {
    if(object === undefined) object = this.props.object;
    if(arrProperties.length === 0) return object;

    const property = arrProperties.shift();
    switch(arrProperties.length) {
      case 0:
        return (object !== undefined && object[property] !== undefined && object[property] !== null) ? object[property] : "";
      default:
        object = object[property];
        return object ? this.getSubObjectProperty(arrProperties, object) : "";
    }
  }

  /**
  * currencyFormatter
  * Formats currency numbers
  **/
  currencyFormatter(cell, row, extraParams) {
    return cell ? cell.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + "€" : cell;
  }

  /**
  * getSousTotal
  * Returns Sous-total
  **/
  getSousTotal() {
    const tarif = this.getObjectProperty("tarif");
    let sousTotal = null;
    const surface = parseFloat(this.getObjectProperty("surface"));
    const tarifValeur = tarif ? parseFloat(tarif.valeur) : null;

    if(!isNaN(tarifValeur) && tarif.unite && tarif.unite.titre === "forfait") {
      sousTotal = tarifValeur;
    } else if(!isNaN(surface) && !isNaN(tarifValeur)) {
      sousTotal = surface * tarifValeur;
    }

    return Math.round(sousTotal * 100) / 100;
  }

  /**
  * getTotal
  * Returns total
  **/
  getTotal() {
    let total = this.getSousTotal();

    if(total !== null) {
      const remise1 = parseFloat(this.getObjectProperty("remise1"));
      const remise2 = parseFloat(this.getObjectProperty("remise2"));
      let remise1Valeur = 0, remise2Valeur = 0;

      if(!isNaN(remise1)) {
        remise1Valeur = total * (remise1 / 100);
      }

      if(!isNaN(remise2)) {
        remise2Valeur = total * (remise2 / 100);
      }

      total += - remise1Valeur - remise2Valeur;
    }

    return Math.round(total * 100) / 100;
  }

  /**
  * getTotalAnnuel
  * Returns total annuel
  **/
  getTotalAnnuel() {
    let total = this.getTotal();
    let ratio = 1;

    switch(this.getSubObjectProperty(["tarif", "uniteTemps", "libelle"])) {
      case "Jour":
        ratio = getDaysInYear();
        break;
      case "Semaine":
        ratio = getWeeksInYear();
        break;
      case "Mois":
        ratio = 12;
        break;
      default:
        break
    }

    return Math.round(total * ratio * 100) / 100;
  }

}

export default TarificationRecap;



// WEBPACK FOOTER //
// ./src/views/Entity/Tarification/TarificationRecap.js